<script setup>
import { Handle, Position } from '@vue-flow/core';
import { NODE_TYPES } from '../../constants';
import FlowNodeCard from './FlowNodeCard.vue';

const props = defineProps({
  data: { type: Object, default: () => ({}) },
  selected: { type: Boolean, default: false },
});
const meta = NODE_TYPES.ask_jhulie;
</script>

<template>
  <FlowNodeCard :icon="meta.icon" :color="meta.color" :title="meta.label" :selected="selected">
    <Handle type="target" :position="Position.Left" />
    <p>Encerra o fluxo e entrega a conversa pra Jhulie (IA) responder.</p>
    <p v-if="data.goal" class="mt-1 text-n-slate-9 line-clamp-2">Objetivo: {{ data.goal }}</p>
  </FlowNodeCard>
</template>
